import { FulfillmentOrderAddressSchema } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateFulfillmentGroupAddress = {
  name: "updateFulfillmentGroupAddress" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    address: FulfillmentOrderAddressSchema,
  }),
  output: z.object({ success: z.boolean() }),
};
